import { cssPrefix } from '../../../../const/Constant';
import { XScreenZone } from './XScreenZone';

class XScreenLZone extends XScreenZone {

  constructor() {
    super(`${cssPrefix}-x-screen-l-zone`);
  }

}

export {
  XScreenLZone,
};
